import React, { useState } from "react";
import { Dialog, Button, Input, Label } from "@/components/ui";

interface SendTestDigestDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (email: string) => void;
  loading?: boolean;
  defaultEmail?: string;
}

export const SendTestDigestDialog: React.FC<SendTestDigestDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  loading,
  defaultEmail = "",
}) => {
  const [email, setEmail] = React.useState(defaultEmail);

  React.useEffect(() => {
    if (open) {
      setEmail(defaultEmail);
    }
  }, [open, defaultEmail]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      onConfirm(email);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size="sm">
      <Dialog.Content className="p-0">
        <Dialog.Header className="px-6 py-4 border-b">
          <Dialog.Title>Send Test Email</Dialog.Title>
          <Dialog.Description>Enter an email address to send a sample of this digest to.</Dialog.Description>
        </Dialog.Header>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="test-email">Email Address</Label>
            <Input
              id="test-email"
              type="email"
              placeholder="e.g. name@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoFocus
              required
            />
          </div>
        </form>

        <Dialog.Footer className="px-6 py-4 bg-slate-50 border-t">
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" onClick={handleSubmit} loading={loading} disabled={!email || loading}>
            Send Test
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};
